export default __webpack_public_path__ + "files/media/plane-desktop.3790c1a0.jpg";